import { Alert, AlertTitle } from '@mui/material'

export default function ConflictWarning({ conflicts }) {
  if (!conflicts || conflicts.length === 0) return null

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>Rule Conflict Detected</AlertTitle>
      {conflicts.map((conflict, i) => (
        <span key={i}>
          {conflict}
          {i < conflicts.length - 1 && <br />}
        </span>
      ))}
    </Alert>
  )
}
